import { Moon, Sun } from 'lucide-react';
import { clsx } from 'clsx';
import { useTheme } from '../../lib/theme';

interface Props {
  /** Icon-only button (default) or a segmented Dark / Light control. */
  variant?: 'icon' | 'segmented';
  className?: string;
}

export function ThemeToggle({ variant = 'icon', className }: Props) {
  const { theme, setTheme, toggle } = useTheme();

  if (variant === 'segmented') {
    return (
      <div className={clsx('inline-flex rounded-full border border-dark-border bg-dark-bg p-0.5', className)}>
        {(['dark', 'light'] as const).map((t) => (
          <button
            key={t}
            onClick={() => setTheme(t)}
            className={clsx('inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12px] capitalize transition-colors cursor-pointer', theme === t ? 'bg-dark-elevated text-dark-text' : 'text-dark-faint hover:text-dark-muted')}
          >
            {t === 'dark' ? <Moon size={12} /> : <Sun size={12} />}
            {t}
          </button>
        ))}
      </div>
    );
  }

  return (
    <button
      onClick={toggle}
      title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label="Toggle theme"
      className={clsx('grid h-7 w-7 place-items-center rounded-md text-dark-faint transition-colors hover:bg-dark-hover hover:text-dark-text cursor-pointer', className)}
    >
      {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}
